import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Header from "../header/Header";
import Icon from "@material-tailwind/react/Icon";
import LOGO_RKS from "../../assets/logo/LOGORKS2.png";
import { Colors } from "../../assets/Colors";
import "./Sidebar.css";
import operational from "../../assets/img/operational.png";
import finance from "../../assets/img/finance.png";
import shield from "../../assets/img/shield.png";
import tools from "../../assets/img/tools.png";
import cart from "../../assets/img/cart.png";
import store from "../../assets/img/store.png";
import accounting from "../../assets/img/accounting.png";
import payroll from "../../assets/img/payroll.png";
import memo from "../../assets/img/memo.png";
import asset from "../../assets/img/assets.png";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showSidebar, setShowSidebar] = useState("-left-64");

  // Bug #1: null-safety — jika localStorage kosong, fallback ke object kosong
  const rawUser = JSON.parse(localStorage.getItem("user") || "null");
  const user = rawUser?.Otoritas ?? {};

  let AuthList = [
    { Name: "Dashboard", Url: "", Icon: "dashboard", Imgs: false },
    { Name: "Approval", Url: "/approval-list", Icon: "check", Imgs: false },
  ];

  if (
    user.SApproval !== 0 ||
    user.SApprovalPC !== 0 ||
    user.SAuth !== 0 ||
    user.SCuti !== 0 ||
    user.SJamKerja !== 0 ||
    user.SLembur !== 0 ||
    user.SPlafonPerobatan !== 0 ||
    user.SSaldoAwal !== 0 ||
    user.SSpecimen !== 0
  ) {
    AuthList.push({ Name: "Setup", Url: "/setup", Icon: "build", Imgs: false });
  }

  if (
    user.MBisnisUnit !== 0 ||
    user.MKota !== 0 ||          // Bug #6: hapus duplikat MKota
    user.MProvinsi !== 0 ||
    user.MBank !== 0 ||
    user.MKlien !== 0 ||
    user.MKendaraan !== 0 ||     // Bug #6: hapus duplikat MKendaraan
    user.MKelompokKegiatan !== 0 ||
    user.MDesa !== 0 ||
    user.MLokasiTugas !== 0 ||
    user.MBagian !== 0 ||
    user.MCuti !== 0 ||
    user.MPenyakit !== 0 ||
    user.MGolongan !== 0 ||
    user.MTipeKaryawan !== 0 ||
    user.MJabatan !== 0 ||
    user.MMainAccount !== 0 ||
    user.MSubAccount !== 0 ||    // Bug #6: hapus duplikat MSubAccount
    user.MDetailAccount !== 0 ||
    user.MCustomer !== 0 ||
    user.MOum !== 0 ||
    user.MSubKegiatan !== 0 ||
    user.MKegiatan !== 0 ||
    user.MLocationUsed !== 0 ||
    user.MLimbah !== 0 ||
    user.MKemasan !== 0 ||
    user.MGeneralServiceUnit !== 0 ||
    user.MRentalUnit !== 0 ||
    user.MJetty !== 0 ||
    user.MRoom !== 0 ||
    user.MMeals !== 0 ||
    user.MTypeOfClothing !== 0 ||
    user.MDestination !== 0 ||
    user.MFuel !== 0 ||
    user.MLabour !== 0 ||
    user.MWasteManagement !== 0 ||
    user.MCargoCarryingUnit !== 0 ||
    user.MAreaRental !== 0 ||
    user.MRental !== 0 ||
    user.MSupplier !== 0 ||
    user.UserPC !== 0 ||
    user.MFranco !== 0 ||
    user.MSatuan !== 0 ||
    user.MKelompok !== 0 ||
    user.MBarang !== 0 ||
    user.MActivity !== 0         // Bug #7: tambah !== 0 agar konsisten
  ) {
    AuthList.push({
      Name: "Master",
      Url: "/master",
      Icon: "settings",
      Imgs: false,
    });
  }

  if (
    user.MKaryawan !== 0 ||
    user.TCuti !== 0 ||
    user.TIzin !== 0 ||
    user.TSakit !== 0 ||
    user.TPerjalananDinas !== 0 ||
    user.MTarifUangSaku !== 0 ||
    user.TMonitoringLPD !== 0 ||
    user.TPelatihan !== 0 ||
    user.TTiket !== 0 ||
    user.TLembur !== 0 ||
    user.TPengobatan !== 0 ||
    user.TPhk !== 0 ||
    user.TResign !== 0 ||
    user.TCSR !== 0 ||
    user.MLKaryawan !== 0 ||
    user.TLCuti !== 0 ||
    user.TLIzin !== 0 ||
    user.TLSakit !== 0 ||
    user.TLPelatihan !== 0 ||
    user.TLTiket !== 0 ||
    user.TLLembur !== 0 ||
    user.TLPengobatan !== 0 ||
    user.TLPhk !== 0 ||
    user.MLFKaryawan !== 0
  ) {
    AuthList.push({
      Name: "Human Resource",
      Url: "/human-resource",
      Icon: "groups",
      Imgs: false,
    });
  }

  if (
    user.TOperationalMonitoring !== 0 ||
    user.TShippingManifest !== 0 ||
    user.TLJobRequest !== 0 ||
    user.TActivity !== 0
  ) {
    AuthList.push({
      Name: "Operational",
      Url: "/operasional",
      Icon: operational,
      Imgs: true,
    });
  }

  // General Affair: otoritas sendiri (GeneralAffair), terpisah dari Job Request Operasional
  if (user.GeneralAffair !== 0) {
    AuthList.push({
      Name: "General Affair",
      Url: "/general-affair",
      Icon: "apartment",
      Imgs: false,
    });
  }

  if (user.TPermit !== 0) {
    AuthList.push({ Name: "HSE", Url: "/hse", Icon: shield, Imgs: true });
  }

  if (
    user.TKendaraan !== 0 ||
    user.TMKendaraan !== 0 ||
    user.TRKendaraan !== 0
  ) {
    AuthList.push({
      Name: "Equipment",
      Url: "/equipment",
      Icon: tools,
      Imgs: true,
    });
  }

  if (
    user.Monitoring_Quotation !== 0 ||
    user.Quotation !== 0 ||
    user.Additional_Quotation !== 0 ||
    user.Permohonan_Pembayaran_PO !== 0 ||
    user.Permohonan_Pembayaran_Non_PO !== 0 ||
    user.Pengeluaran_Kas_HO !== 0 ||
    user.Pengeluaran_Kas_SO !== 0 ||
    user.Penerimaan_Kas_HO !== 0 ||
    user.Penerimaan_Kas_SO !== 0 ||
    user.Penerimaan_Dana !== 0 ||
    user.Invoice_Job_Request !== 0 ||
    user.Buku_Kas_HO !== 0 ||    // Bug #6: hapus duplikat Buku_Kas_HO (3x → 1x)
    user.Buku_Kas_SO !== 0 ||
    user.Buku_Bank_HO !== 0 ||
    user.Buku_Bank_SO !== 0 ||
    user.Monitoring_Pembayaran_PO !== 0 ||
    user.Monitoring_Pembayaran_Non_PO !== 0 ||
    user.Monitoring_Penerimaan_Dana !== 0
  ) {
    AuthList.push({
      Name: "Finance",
      Url: "/finance",
      Icon: finance,
      Imgs: true,
    });
  }

  if (
    user.PurchaseRequisition !== 0 ||
    user.Allocation !== 0 ||
    user.PriceComparison !== 0 ||  // Bug #6: hapus duplikat PriceComparison
    user.OrderWarehouse !== 0 ||
    user.MonitoringPurchaseRequisition !== 0 ||
    user.LaporanPurchaseOrder !== 0 ||
    user.MonitoringPurchraseOrder !== 0 ||
    user.MonitoringPriceComparison !== 0
  ) {
    AuthList.push({
      Name: "Procurement",
      Url: "/procurment",
      Icon: cart,
      Imgs: true,
    });
  }

  if (
    user.GoodsAcceptance !== 0 ||
    user.GoodsExpenditure !== 0 ||
    user.GoodsReturn !== 0 ||      // Bug #6: hapus duplikat GoodsReturn
    user.GoodsStock !== 0 ||
    (user.POTransit || 0) !== 0 ||
    user.GoodsPenerimaan !== 0 ||
    user.GoodsLapPenerimaan !== 0 ||
    user.GoodsPengeluaran !== 0
  ) {
    AuthList.push({ Name: "Gudang", Url: "/gudang", Icon: store, Imgs: true });
  }

  if (
    user.Jurnal !== 0 ||           // Bug #6: hapus duplikat Jurnal
    user.Monitoring_Jurnal !== 0 ||
    user.Account_Payable !== 0 ||
    user.Buku_Besar !== 0 ||
    user.Trial_Balance !== 0 ||
    user.Neraca !== 0 ||
    user.Laba_Rugi !== 0 ||
    user.Closing !== 0
  ) {
    AuthList.push({
      Name: "Accounting",
      Url: "/Accounting",
      Icon: accounting,
      Imgs: true,
    });
  }

  if (user.Payroll !== 0) {
    AuthList.push({
      Name: "Payroll",
      Url: "/payroll",
      Icon: payroll,
      Imgs: true,
    });
  }

  if (user.InternalMemo !== 0 || user.InternalMemoReport !== 0) {
    AuthList.push({
      Name: "Memo",
      Url: "/memo",
      Icon: memo,
      Imgs: true,
    });
  }

  // Bug #5: tutup sidebar otomatis saat NavLink diklik (mobile)
  const handleNavClick = () => {
    if (showSidebar === "left-0") {
      setShowSidebar("-left-64");
    }
  };

  function sidebarList(name, icon, path, image, key) {
    return (
      <li key={key} className="rounded-lg mb-2">
        <NavLink
          to={path}
          onClick={handleNavClick}
          style={(navData) =>
            navData.isActive ? { background: Colors.primary } : {}
          }
          className={(navData) =>
            navData.isActive
              ? "flex items-center gap-4 px-4 py-3 rounded-lg text-white shadow-md img-invert"
              : "flex items-center gap-4 px-4 py-3 rounded-lg text-sm text-gray-700 font-light"
          }
        >
          {!image ? (
            <Icon name={icon} size="1xl" />
          ) : (
            <img src={icon} className="sidebar-icon" alt={name} />
          )}
          {name}
        </NavLink>
      </li>
    );
  }

  return (
    <>
      {/* Bug #3: hapus key={showSidebar} agar Header tidak remount setiap sidebar toggle */}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div
        className={`no-scrollbar h-full fixed top-0 md:left-0 ${showSidebar} overflow-y-auto flex-row flex-nowrap overflow-hidden shadow-xl bg-white w-64 z-10 py-4 px-6 transition-all duration-300`}
      >
        <div className="no-scrollbar flex-col items-stretch min-h-full flex-nowrap px-0 relative">
          {/* Bug #8: ganti <a> menjadi <button> karena tidak ada href */}
          <button
            type="button"
            className="mt-2 w-full flex flex-col items-center bg-transparent border-0 cursor-pointer"
            onClick={() => { navigate("/"); handleNavClick(); }}
          >
            <img
              src={LOGO_RKS}
              alt="RKS Logo"
              className="w-48 h-24 object-contain"
            />
            <span className="text-xs text-gray-500 mt-1">Shorebase Activities Management System</span>
          </button>
          <div className="flex flex-col">
            <hr className="my-4 min-w-full" />
            <ul className="flex-col min-w-full flex list-none mainmenu">
              {AuthList.map((item, index) =>
                sidebarList(
                  item.Name,
                  item.Icon,
                  item.Url,
                  item.Imgs,
                  `${item.Name || index}-${index}`
                )
              )}
              <li className="rounded-lg mb-2 text-center text-gray-400 mt-48">
                BETA V1.5.0
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
